export const siteNav = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/site/services" },
  { label: "About", to: "/site/about" },
  { label: "Contact", to: "/site/contact" },
];

export const heroStats = [
  { value: "12,400+", label: "Moves completed" },
  { value: "4.9", label: "Avg customer rating" },
  { value: "18", label: "Years on the road" },
  { value: "32", label: "Cities served" },
];

export const services = [
  {
    id: "residential",
    icon: "ri-home-smile-line",
    title: "Residential Moves",
    tagline: "Apartments, condos & single-family homes",
    description:
      "From studios to five-bedroom houses, we pack, load, drive, and unload with the kind of care you'd give your own grandmother's china.",
    features: ["Full packing service", "Furniture disassembly", "Floor & wall protection", "Same-day options"],
    startingPrice: 189,
    color: "from-brand-500 to-brand-700",
  },
  {
    id: "commercial",
    icon: "ri-building-2-line",
    title: "Office & Commercial",
    tagline: "Offices, retail & light industrial",
    description:
      "Weeknight and weekend office relocations with minimal downtime. IT equipment, modular furniture, files — handled with chain-of-custody tracking.",
    features: ["After-hours scheduling", "IT & server moves", "Labeled crate program", "Building COI provided"],
    startingPrice: 480,
    color: "from-ink-800 to-ink-900",
  },
  {
    id: "long-distance",
    icon: "ri-roadster-line",
    title: "Long Distance",
    tagline: "Cross-state & coast-to-coast",
    description:
      "Dedicated trucks (no shared loads) with GPS tracking and a single crew from origin to destination. Delivery windows you can actually plan around.",
    features: ["Dedicated truck", "Live GPS tracking", "Guaranteed delivery date", "Climate-controlled options"],
    startingPrice: 2350,
    color: "from-brand-600 to-brand-800",
  },
  {
    id: "packing",
    icon: "ri-archive-2-line",
    title: "Packing & Unpacking",
    tagline: "Full-service or partial",
    description:
      "Our packers bring premium boxes, custom crating, and a labeling system that makes unpacking feel like opening presents instead of a scavenger hunt.",
    features: ["Premium materials included", "Custom crating", "Wardrobe boxes", "Unpacking service"],
    startingPrice: 95,
    color: "from-amber-500 to-orange-600",
  },
  {
    id: "storage",
    icon: "ri-inbox-archive-line",
    title: "Storage Solutions",
    tagline: "Short-term & long-term",
    description:
      "Climate-controlled vaults at our secure warehouses. We move it in, we move it out — no truck rental, no self-storage hassle.",
    features: ["Climate-controlled", "24/7 monitoring", "Inventory portal", "Flexible terms"],
    startingPrice: 65,
    color: "from-emerald-600 to-emerald-800",
  },
  {
    id: "specialty",
    icon: "ri-music-2-line",
    title: "Specialty Items",
    tagline: "Pianos, art, antiques, gun safes",
    description:
      "Heirlooms, baby grands, sculpture, 800-lb gun safes — items most movers refuse, we specialize in. Custom rigging and insured to full replacement value.",
    features: ["Piano specialists", "Art crating", "Heavy item rigging", "Full-value insurance"],
    startingPrice: 320,
    color: "from-rose-600 to-rose-800",
  },
];

export const processSteps = [
  {
    n: "01",
    icon: "ri-chat-quote-line",
    title: "Free Quote",
    description: "Tell us about your move in 60 seconds — get a transparent, all-in estimate (no surprises) within the hour.",
  },
  {
    n: "02",
    icon: "ri-calendar-check-line",
    title: "Pick Your Date",
    description: "Lock in your move date with a small deposit. We'll send a digital pre-move checklist so nothing falls through the cracks.",
  },
  {
    n: "03",
    icon: "ri-truck-line",
    title: "We Show Up",
    description: "On time, uniformed, with floor runners and shrink wrap. A real lead mover walks you through the plan before lifting anything.",
  },
  {
    n: "04",
    icon: "ri-key-2-line",
    title: "Settle In",
    description: "We place furniture, reassemble beds, and clean up boxes. You get the keys to your new place ready to live in — not unpack for weeks.",
  },
];

export const whyUs = [
  {
    icon: "ri-shield-check-line",
    title: "Licensed, bonded & insured",
    description: "USDOT #2841930 · MC-984210 · Full-replacement-value coverage included on every move.",
  },
  {
    icon: "ri-time-line",
    title: "On-time guarantee",
    description: "Show up more than 30 minutes late and your first hour is on us. We've paid it out twice in two years.",
  },
  {
    icon: "ri-team-line",
    title: "Background-checked crews",
    description: "Every crew member is W-2, drug-tested, background-checked, and trained at our own training facility.",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Flat-rate pricing",
    description: "No hourly meter anxiety. You get an all-in price before we lift a single box, locked-in at booking.",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "Madeline Okafor",
    role: "Moved Brooklyn → Hoboken",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20warm%20smiling%20professional%20woman%20in%20her%20early%20thirties%20with%20natural%20curly%20hair%20wearing%20a%20cream%20sweater%20against%20a%20soft%20blurred%20neutral%20beige%20studio%20background%20with%20natural%20lighting%20and%20a%20relaxed%20genuine%20expression&width=120&height=120&seq=test-mover-1&orientation=squarish",
    rating: 5,
    quote:
      "Booked them on a Tuesday for a Saturday move and they crushed it. Three guys, four hours, zero damage to a glass dining table that scares every mover I've used before.",
  },
  {
    id: "t2",
    name: "Daniel Whitfield",
    role: "Owner, Atelier Studio",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20professional%20man%20in%20his%20forties%20with%20short%20dark%20hair%20and%20a%20trimmed%20beard%20wearing%20a%20charcoal%20button%20down%20shirt%20with%20a%20confident%20friendly%20expression%20against%20a%20soft%20blurred%20cream%20studio%20background%20with%20warm%20natural%20lighting&width=120&height=120&seq=test-mover-2&orientation=squarish",
    rating: 5,
    quote:
      "Moved our 22-person office overnight on a Saturday. Monday morning every workstation was set up, networked, and labeled. Genuinely the smoothest vendor experience I've had in 15 years.",
  },
  {
    id: "t3",
    name: "Priya Ramaswamy",
    role: "Moved NYC → Austin",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20warm%20smiling%20woman%20in%20her%20mid%20thirties%20with%20long%20dark%20hair%20wearing%20a%20rust%20colored%20blouse%20against%20a%20soft%20blurred%20neutral%20beige%20studio%20background%20with%20natural%20lighting%20and%20a%20genuine%20happy%20expression&width=120&height=120&seq=test-mover-3&orientation=squarish",
    rating: 5,
    quote:
      "Cross-country with a dedicated truck — they told us Thursday delivery and the truck pulled up Thursday at 9:14 AM. The same two movers from NY unloaded in Austin. Unreal.",
  },
  {
    id: "t4",
    name: "Marco Delgado",
    role: "Moved Manhattan → Queens",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20friendly%20man%20in%20his%20late%20twenties%20with%20short%20wavy%20brown%20hair%20wearing%20a%20cream%20henley%20shirt%20against%20a%20soft%20blurred%20warm%20beige%20studio%20background%20with%20natural%20lighting%20and%20an%20approachable%20smile&width=120&height=120&seq=test-mover-4&orientation=squarish",
    rating: 5,
    quote:
      "I had a 1965 Steinway upright and four other movers had quoted me ridiculous prices or just said no. Haulmark sent a 4-person specialty crew and it was at my new place by lunch.",
  },
  {
    id: "t5",
    name: "Eleanor Park",
    role: "Moved Jersey City → Park Slope",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20professional%20woman%20in%20her%20early%20fifties%20with%20shoulder%20length%20silver%20hair%20wearing%20a%20soft%20camel%20cardigan%20against%20a%20soft%20blurred%20neutral%20cream%20studio%20background%20with%20natural%20lighting%20and%20a%20kind%20genuine%20smile&width=120&height=120&seq=test-mover-5&orientation=squarish",
    rating: 5,
    quote:
      "Hired them for my elderly mother's downsize. The crew was patient, kind, set up her bed and TV before they left, and even took the empty boxes away. I cannot recommend them more.",
  },
  {
    id: "t6",
    name: "James O'Reilly",
    role: "Moved Long Island → Hudson Valley",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20professional%20man%20in%20his%20fifties%20with%20greying%20hair%20wearing%20a%20warm%20brown%20sweater%20against%20a%20soft%20blurred%20neutral%20beige%20studio%20background%20with%20warm%20natural%20lighting%20and%20a%20confident%20happy%20expression&width=120&height=120&seq=test-mover-6&orientation=squarish",
    rating: 5,
    quote:
      "Quoted flat-rate, finished two hours under estimate, and refunded the difference without me even asking. Who does that? Haulmark does, apparently. Customer for life.",
  },
];

export const faqs = [
  {
    q: "How far in advance should I book my move?",
    a: "For weekday moves, 1-2 weeks is usually plenty. For weekends and end-of-month dates (especially May-September), aim for 3-4 weeks out. That said, we hold a few same-week slots open for last-minute moves — just call and ask.",
  },
  {
    q: "Are your prices flat-rate or hourly?",
    a: "Both! Local moves under 50 miles default to flat-rate (no surprises), and longer or larger jobs are quoted as fixed bids. We never use an hourly meter that ticks up — you'll know the all-in price before we lift a single box.",
  },
  {
    q: "What's included in the standard rate?",
    a: "Truck, fuel, tolls, blanket-wrap, basic shrink-wrap, dollies, floor runners, two flights of stairs at each end, basic furniture disassembly and reassembly, and full-replacement-value insurance. No hidden fees, ever.",
  },
  {
    q: "Do you do packing?",
    a: "Yes — full-service, partial (e.g. just kitchen + fragile), or you-pack-we-move. Packing crews bring premium materials and a labeling system that makes unpacking dramatically easier.",
  },
  {
    q: "What if something gets damaged?",
    a: "Every move is covered by full-replacement-value insurance at no extra cost. If we damage something, we either repair it, replace it, or pay you its current replacement value — your choice, not ours. Claims are handled by a real human, not a portal.",
  },
  {
    q: "Do you move pianos / safes / hot tubs?",
    a: "Yes to all three. We have a dedicated specialty crew with proper rigging equipment (piano boards, J-bars, stair climbers, etc.) and the insurance to cover items most movers won't touch.",
  },
];

export const aboutStats = [
  { value: "2007", label: "Founded" },
  { value: "12,400+", label: "Moves completed" },
  { value: "38", label: "Crew members" },
  { value: "4.9★", label: "Avg rating" },
];

export const teamMembers = [
  {
    id: "tm1",
    name: "Sofía Mendoza",
    role: "Founder & CEO",
    bio: "Started Haulmark in 2007 with a single box truck and a flip phone. Still answers the customer hotline herself when she's in the office.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20confident%20latina%20business%20woman%20in%20her%20mid%20forties%20with%20shoulder%20length%20dark%20hair%20wearing%20a%20warm%20cream%20blazer%20against%20a%20soft%20blurred%20neutral%20beige%20studio%20background%20with%20natural%20lighting%20and%20a%20warm%20genuine%20smile&width=400&height=520&seq=team-1&orientation=portrait",
  },
  {
    id: "tm2",
    name: "Marcus Holloway",
    role: "Operations Director",
    bio: "Former Air Force logistics. Plans every dispatch and route with military precision. Also makes the best office coffee.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20confident%20black%20business%20man%20in%20his%20late%20thirties%20with%20short%20hair%20and%20a%20trimmed%20beard%20wearing%20a%20charcoal%20henley%20shirt%20against%20a%20soft%20blurred%20warm%20cream%20studio%20background%20with%20natural%20lighting%20and%20a%20confident%20warm%20expression&width=400&height=520&seq=team-2&orientation=portrait",
  },
  {
    id: "tm3",
    name: "Chen Wei",
    role: "Head of Crew",
    bio: "Lead mover for 12 years before taking over crew training. Knows every truck, every tool, and every team member by name.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20friendly%20asian%20man%20in%20his%20early%20forties%20with%20short%20black%20hair%20wearing%20a%20warm%20rust%20colored%20henley%20shirt%20against%20a%20soft%20blurred%20warm%20cream%20studio%20background%20with%20natural%20lighting%20and%20a%20genuine%20friendly%20smile&width=400&height=520&seq=team-3&orientation=portrait",
  },
  {
    id: "tm4",
    name: "Aaliyah Brooks",
    role: "Customer Experience",
    bio: "Runs the customer support team and the feedback program. If something goes sideways, she's the one who makes it right.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20warm%20smiling%20black%20business%20woman%20in%20her%20early%20thirties%20with%20natural%20curly%20hair%20wearing%20a%20warm%20camel%20blouse%20against%20a%20soft%20blurred%20neutral%20cream%20studio%20background%20with%20natural%20lighting%20and%20a%20genuine%20happy%20expression&width=400&height=520&seq=team-4&orientation=portrait",
  },
];

export const aboutValues = [
  {
    icon: "ri-shake-hands-line",
    title: "Treat every box like it's ours",
    description: "We move things that matter to people. Heirlooms, first apartments, baby grands — the work isn't about furniture, it's about trust.",
  },
  {
    icon: "ri-eye-line",
    title: "Radical transparency",
    description: "Flat-rate quotes, itemized invoices, real photos of damage if it happens. No portal-only claims processes or fine-print surprises.",
  },
  {
    icon: "ri-medal-line",
    title: "Pay & train our people well",
    description: "Our crews are W-2 employees with benefits and real training — not 1099 contractors hired off Craigslist for a Saturday.",
  },
];

export const contactInfo = {
  phoneSales: "(347) 555-0142",
  phoneSupport: "(347) 555-0188",
  email: "hello@haulmarkmovers.com",
  address: "412 Industry Court, Brooklyn, NY 11237",
  hours: [
    { day: "Mon – Fri", time: "7:00 AM – 8:00 PM" },
    { day: "Saturday", time: "8:00 AM – 6:00 PM" },
    { day: "Sunday", time: "9:00 AM – 4:00 PM" },
  ],
  serviceAreas: ["Brooklyn", "Manhattan", "Queens", "Bronx", "Staten Island", "Jersey City", "Hoboken", "Long Island", "Westchester", "Hudson Valley"],
};

export const partnerLogos = [
  "Better Business Bureau A+",
  "Angi Super Service",
  "Google 5-Star Rated",
  "Yelp Top 100",
  "AMSA ProMover",
  "Houzz Best of Service",
];